import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { env } from "@environments/environment";

@Injectable({ providedIn: "root" })
export class RecipientSeriesController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;
  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1/distribution/series`;

  public getDistributionSeries(distributionId: number): Observable<any[]> {
    return this.httpService.get(`${this.baseUrl}/distribution-goods/${distributionId}`, { responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public getDistributionSeriesByRegion(id: number): Observable<any[]> {
    return this.httpService.get(`${this.baseUrl}/recipient/${id}`, { responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public createSeriesByRegion(recipientId: number, seriesData: any): Observable<any>  {
    const headers = new HttpHeaders().set("Content-type", "application/json");
    return this.httpService.post(`${this.baseUrl}/recipient/${recipientId}`, JSON.stringify(seriesData), { headers, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public updateQuntity(data: any): Observable<any>  {
    const headers = new HttpHeaders().set("Content-type", "application/json");
    return this.httpService.put(`${this.baseUrl}/recipient`, JSON.stringify(data), { headers, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public deleteSeries(recipientSeriesId: number | null): Observable<void>  {
    return this.httpService.delete<void>(`${this.baseUrl}/recipient/${recipientSeriesId}`);
  }

  public getDistributionDozSeriesByRecipient(id: number): Observable<any[]> {
    return this.httpService.get(`${this.baseUrl}/beneficiary/${id}`, { responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public getDistributionDozSeries(regionRecipientId: number): Observable<any[]> {
    return this.httpService.get(`${this.baseUrl}/beneficiary/recipient/${regionRecipientId}`, { responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public createSeriesByRecipientDoz(recipientId: number, specificationIds: any): Observable<any>  {
    const headers = new HttpHeaders().set("Content-type", "application/json");
    return this.httpService.post(`${this.baseUrl}/beneficiary/${recipientId}`, JSON.stringify(specificationIds), { headers, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public updateQuntityDoz(data: any): Observable<any>  {
    const headers = new HttpHeaders().set("Content-type", "application/json");
    return this.httpService.put(`${this.baseUrl}/beneficiary`, JSON.stringify(data), { headers, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public deleteSeriesDoz(distributionRecipientSpecificationId: number | null): Observable<void>  {
    return this.httpService.delete<void>(`${this.baseUrl}/beneficiary/${distributionRecipientSpecificationId}`);
  }
}
